import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-950 font-heading">
                蜜桃视频在线
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              蜜桃视频在线是您最佳的高清视频在线观看平台，海量精选视频内容免费畅享，无需下载即可流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/hot" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/movie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                电影
              </Link>
              <Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                电视剧
              </Link>
              <Link to="/category/variety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                综艺
              </Link>
              <Link to="/category/anime" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                动漫
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 蜜桃视频在线. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors">
              隐私政策
            </a>
            <a href="#" className="hover:text-foreground-700 transition-colors">
              服务条款
            </a>
            <a href="#" className="hover:text-foreground-700 transition-colors">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}